// eslint-disable-next-line
import React, {  useState } from 'react';
import {  useSelector } from 'react-redux';

// Material-UI components
import ButtonLink from '@mui/material/Link';
import {
    Button,
    Typography,
    CircularProgress,
    Box,
} from '@mui/material';
import { BrandedCardContainer } from '../../components/BrandedCardContainer/BrandedCardContainer';

// Constants
import * as PXBColors from '@brightlayer-ui/colors';
import ProjectName from '../../assets/images/safety-management-system.svg'
import BackgroundImage from '../../assets/images/Login_Background.png';
import cyberCertifyLogo from '../../assets/images/cybersecurity_certified.svg';
import { Selectors } from '../../selectors';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { EmptyState } from '@brightlayer-ui/react-components';
import { useOktaAuth } from '@okta/okta-react';


type Props = {
    email: string;
    changeNextEnabled: Function;
    singUpClick: Function;
};

const RegisterLogin: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {

    
    const { t } = useLanguageLocale();
    const inActiveLogoutMessage = useSelector(Selectors.Dashboard.inActiveLogOut);
    const loginState = useSelector(Selectors.Authentication.login);
    const [inActiveLogout, setInactiveLogOut] = useState(inActiveLogoutMessage);
    const { oktaAuth } = useOktaAuth();
    const handleOnLogin = async (): Promise<void> => {
        try {
            setInactiveLogOut(false);
            await oktaAuth.signInWithRedirect();
        } catch (_error) {
            // eslint-disable-next-line no-console
            console.log(_error as Error);
        } finally {
            // eslint-disable-next-line no-console
            // console.log('finally');
        }
    };
   
    const goToSignUp = (): void => {
        if (props.singUpClick) {
            props.singUpClick();
        }
    };

    return (
        <>
            <BrandedCardContainer>
                <>
                    {loginState.loading && <EmptyState style={{ flex: 1, backgroundColor: PXBColors.white[50] }}
                        icon={<CircularProgress id="progress-spinner" />} title={t('LABELS.LOGGING_IN')} placeholder={undefined} />
                    }
                    {!loginState.loading &&
                        <div>
                           <div style={{ padding: '0px' }} data-testid="login-form">
                                <div
                                    className="bg_image"
                                    style={{
                                        backgroundImage: `url(${BackgroundImage})`,
                                        backgroundSize: 'cover',
                                        top: '150px',
                                        height: '150px',
                                        color: '#FFFFFF',
                                    }}
                                >
                                    <div style={{ display: 'flex' }}>
                                        <img
                                            data-testid="logo"
                                            style={{ paddingTop: 50, paddingLeft: 50, paddingRight: '30px', display: 'flex', flexDirection: 'column' }}
                                            src={ProjectName}
                                            alt="logo"
                                        />
                                    </div>
                                </div>
                                {inActiveLogout && (
                                    <Typography
                                        variant="subtitle1"
                                        color="error"
                                        style={{ paddingBottom: 10, paddingLeft: 25 }}
                                    >
                                        {t('INACTIVITY.INACTIVE_LOGOUT')}
                                    </Typography>
                                )}
                            </div>
                            <div style={{ padding: '0px 40px', display: 'flex', flexDirection: 'column' }}>
                             
                                <Box
                                    sx={{
                                        my: 5,
                                    }}
                                >
                                    <Button
                                        onClick={(): void => {
                                            void handleOnLogin();
                                        }}
                                        variant="contained"
                                        color="primary"
                                        sx={{
                                            width: '100%',
                                        }}
                                    >
                                        {t('LABELS.SIGN_IN')}
                                    </Button>
                                </Box>

                                <div data-testid='forgotpasswordId' style={{ textAlign: 'center', paddingBottom: 32 }}>
                                    <Typography data-testid='needAnAccountId' variant="body2">
                                        {t('LABELS.NEED_ACCOUNT')}{' '}
                                        <ButtonLink
                                            component='button'
                                            variant="body2"
                                            data-testid="sign-up-link"
                                            onClick={(): void => {
                                                goToSignUp()
                                            }}
                                        >
                                            {t('LABELS.SIGN_UP')}
                                        </ButtonLink>
                                    </Typography>
                                    <br />
                                </div>
                                <div style={{ textAlign: 'center' }} data-testid="cyber-logo">
                                    <img src={cyberCertifyLogo} alt="logo" />
                                </div>
                            </div>
                        </div>
                    }
                </>
            </BrandedCardContainer>
        </>
    );
};
export { RegisterLogin };
